import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { FT_PI_BREAKFAST_PROMO_CODE, PROMO_CODE_COOKIE, SESSION_STORAGE_PROMO_COOKIE_SET, PageName } from '@whitbread-eos/api';
import { useFeatureToggle, setCookieWithDefaultDomain, getCookie } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PromoCode(_ref) {
  var roomRates = _ref.roomRates,
    promoCodeFromUrl = _ref.promoCodeFromUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var _useFeatureToggle = useFeatureToggle(),
    isBreakfastPromoCodeEnabled = _useFeatureToggle[FT_PI_BREAKFAST_PROMO_CODE];
  var breakfastPromoCode = t('config.experiments.breakfastPromoCode.code');
  var enabled = t('config.experiments.breakfastPromoCode.isAvailable') === 'true';
  var availableText = t('config.experiments.breakfastPromoCode.available');
  var notAvailableText = t('config.experiments.breakfastPromoCode.notAvailable');
  var selectionInvalidText = t('config.experiments.breakfastPromoCode.selectionInvalid');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasValidCookie = _useState2[0],
    setHasValidCookie = _useState2[1];
  var isValidUrlCode = !!promoCodeFromUrl && promoCodeFromUrl === breakfastPromoCode;
  useEffect(() => {
    setHasValidCookie(getCookie(PROMO_CODE_COOKIE) === breakfastPromoCode);
  }, [breakfastPromoCode]);
  useEffect(() => {
    if (promoCodeFromUrl === undefined || !isBreakfastPromoCodeEnabled) return;
    var currentPromoCodeCookie = getCookie(PROMO_CODE_COOKIE);
    var isPromoCookieSetByUrlFlow = sessionStorage.getItem(SESSION_STORAGE_PROMO_COOKIE_SET) === 'true';
    if (isValidUrlCode && enabled) {
      setCookieWithDefaultDomain(PROMO_CODE_COOKIE, breakfastPromoCode, undefined);
      sessionStorage.setItem(SESSION_STORAGE_PROMO_COOKIE_SET, 'true');
    } else if (currentPromoCodeCookie === breakfastPromoCode || isPromoCookieSetByUrlFlow) {
      setCookieWithDefaultDomain(PROMO_CODE_COOKIE, null, -1);
      sessionStorage.removeItem(SESSION_STORAGE_PROMO_COOKIE_SET);
    }
    setHasValidCookie(getCookie(PROMO_CODE_COOKIE) === breakfastPromoCode);
  }, [promoCodeFromUrl, isBreakfastPromoCodeEnabled, isValidUrlCode, enabled, breakfastPromoCode]);
  if (!isBreakfastPromoCodeEnabled) {
    return null;
  }
  var promoBannerVisibilityPages = t('config.experiments.breakfastPromoCode.promoBannerVisibility').split(',').map(page => page.trim()).filter(Boolean);
  var getPageName = () => {
    if (router.pathname.includes('home')) return PageName.HOME;
    if (router.pathname.includes('search')) return PageName.SRP;
    if (router.pathname.includes('hotels')) return PageName.HDP;
    return null;
  };
  var currentPage = getPageName();
  var isPromoBannerVisible = promoBannerVisibilityPages.length === 0 || currentPage !== null && promoBannerVisibilityPages.includes(currentPage);
  if (isValidUrlCode && !enabled && isPromoBannerVisible) {
    return _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "HeaderBreakfastPromoCode"
    }, headerBreakfast), notAvailable), {}, {
      children: notAvailableText
    }));
  }
  if (hasValidCookie && isPromoBannerVisible) {
    var styles = enabled ? available : notAvailable;
    var text = enabled ? availableText : notAvailableText;
    if (enabled && Array.isArray(roomRates)) {
      var hasPromoRate = roomRates.some(roomRate => roomRate.promotionCode === breakfastPromoCode);
      if (!hasPromoRate) {
        styles = notAvailable;
        text = selectionInvalidText;
      }
    }
    return _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "HeaderBreakfastPromoCode"
    }, headerBreakfast), styles), {}, {
      children: text
    }));
  }
  return null;
}
var headerBreakfast = {
  align: 'center',
  padding: '0.125rem',
  fontWeight: 'bold',
  fontSize: '1rem'
};
var available = {
  background: 'var(--chakra-colors-promoCodeAvailable)'
};
var notAvailable = {
  background: 'var(--chakra-colors-promoCodeNotAvailable)',
  color: 'var(--chakra-colors-baseWhite)'
};